<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="authors-note">
<h1>Author’s Note</h1>
<p>For a glossary of the language used by members of the heist industry, see the Appendix at the end of the book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?119d34b4